import { createContext } from "react";

export const NotificationContext = createContext(null);

export const handleError = (err, setNotification) => {
  setNotification({
    message: "An error has occurred.",
    error_message: err
  });
  console.error("Error caught in handleError:", err);
};
